<template>
    <main-content>
        <rejected_status_description></rejected_status_description>
        <div v-if="dashboard">
            <div v-if="dashboard.user_data && dashboard.admin_data">
                <ul class="nav nav-pills" role="tablist">
                    <li class="nav-item" @click="changeBoard(1)">
                        <a class="nav-link active" data-toggle="tab" href="#admin_pnl" role="tab" aria-selected="false">
                            {{ $t('dashboard.label.pf_panel') }}
                        </a>
                    </li>
                    <li class="nav-item" @click="changeBoard(0)">
                        <a class="nav-link" data-toggle="tab" href="#user_pnl" role="tab" aria-selected="false">
                            {{ $t('dashboard.label.user_ship') }}
                        </a>
                    </li>
                </ul>
                <div class="tab-content">
                    <div id="admin_pnl" class="tab-pane active">
                        <admin-data :admin_data="dashboard.admin_data"></admin-data>
                    </div>
                    <div id="user_pnl" class="tab-pane">
                        <user-data :user_data="dashboard.user_data"></user-data>
                    </div>
                </div>
                <div id="chart">
                    <div v-if="board === 0">
                        <kt-row v-if="dashboard.user_data">
                            <div v-if="dashboard.user_data.pf_tr_chart" class="col-lg-12 col-md-12 col-sm-12">
                                <user-monthly-transaction-chart chart_id="user_tr_chart" :chart_data="dashboard.user_data.pf_tr_chart"/>
                            </div>
                        </kt-row>
                    </div>
                    <div v-else-if="board === 1">
                        <div class="row" v-if="dashboard.admin_data">
                            <br>
<!--                            <div id="pf1" class="col-12 bg-white border my-2" v-if="dashboard.admin_data.pf_tr_chart">-->
<!--                                <div v-text="$t('label.pf_tr_chart')" class="p-2"></div>-->
<!--                                <monthly-transaction-chart chart_id="admin_pf_tr_chart" :chart_data="dashboard.admin_data.pf_tr_chart"-->
<!--                                                           chart_base="price"/>-->
<!--                            </div>-->
<!--                            <div id="pf2" class="col-12 bg-white border my-2"  v-if="dashboard.admin_data.pf_tr_chart">-->
<!--                                <div v-text="$t('label.pf_tr_chart_count')" class="p-2"></div>-->
<!--                                <monthly-transaction-chart chart_id="admin_pf_tr_chart_221" :chart_data="dashboard.admin_data.pf_tr_chart"-->
<!--                                                           chart_base="count"/>-->
<!--                            </div>-->

                            <div  v-if="dashboard.admin_data.pf_succeed_tr_chart_based_psp"
                                  class="col-12 bg-white border my-2">
                              <div class="p-2">{{ $t('label.pf_tr_chart_based_psp') }}</div>
                              <monthly-transaction-chart-based-psp chart_id="pf_succeed_tr_chart_based_psp_1"
                                                                   :chart_data="dashboard.admin_data.pf_succeed_tr_chart_based_psp"
                                                                   chart_base="price"
                              />
                            </div>
                            <div  v-if="dashboard.admin_data.pf_succeed_tr_chart_based_psp"
                                  class="col-12 bg-white border my-2">
                                <div class="p-2">{{ $t('label.pf_tr_chart_based_psp_count') }}</div>
                                <monthly-transaction-chart-based-psp chart_id="pf_succeed_tr_chart_based_psp_2"
                                                                     :chart_data="dashboard.admin_data.pf_succeed_tr_chart_based_psp"
                                                                     chart_base="count"
                                />
                            </div>

                            <br>
<!--                            <div  v-if="dashboard.admin_data.collective_tr_chart"-->
<!--                                  class="col-12 bg-white border my-2">-->
<!--                                <div v-text="$t('label.collective_tr_chart')" class="p-2"></div>-->
<!--                                <monthly-transaction-chart chart_id="admin_collective_tr_chart_3"-->
<!--                                                           :chart_data="dashboard.admin_data.collective_tr_chart"-->
<!--                                                           chart_base="price"/>-->
<!--                            </div>-->
<!--                            <div  v-if="dashboard.admin_data.collective_tr_chart"-->
<!--                                  class="col-12 bg-white border my-2">-->
<!--                                <div v-text="$t('label.collective_tr_chart_count')" class="p-2"></div>-->
<!--                                <monthly-transaction-chart chart_id="admin_collective_tr_chart_7"-->
<!--                                                           :chart_data="dashboard.admin_data.collective_tr_chart"-->
<!--                                                           chart_base="count"-->
<!--                                />-->
<!--                            </div>-->

<!--                            <div  v-if="dashboard.admin_data.collective_tr_chart_based_psp"-->
<!--                                  class="col-12 bg-white border my-2">-->
<!--                              <div class="p-2">{{ $t('label.collective_tr_chart_based_psp') }}</div>-->
<!--                              <monthly-transaction-chart-based-psp chart_id="collective_tr_chart_based_psp_1"-->
<!--                                                         :chart_data="dashboard.admin_data.collective_tr_chart_based_psp"-->
<!--                                                         chart_base="price"-->
<!--                              />-->
<!--                            </div>-->

<!--                            <div  v-if="dashboard.admin_data.collective_tr_chart_based_psp"-->
<!--                                  class="col-12 bg-white border my-2">-->
<!--                              <div class="p-2">{{ $t('label.collective_tr_chart_based_psp_count') }}</div>-->
<!--                              <monthly-transaction-chart-based-psp chart_id="collective_tr_chart_based_psp_2"-->
<!--                                                         :chart_data="dashboard.admin_data.collective_tr_chart_based_psp"-->
<!--                                                         chart_base="count"-->
<!--                              />-->
<!--                            </div>-->

<!--                            <div  v-if="dashboard.admin_data.collective_on_payment_helper_tr_chart_based_psp"-->
<!--                                  class="col-12 bg-white border my-2">-->
<!--                              <div class="p-2">{{ $t('label.collective_on_payment_helper_tr_chart_based_psp') }}</div>-->
<!--                              <monthly-transaction-chart-based-psp chart_id="collective_on_payment_helper_tr_chart_based_psp_1"-->
<!--                                                         :chart_data="dashboard.admin_data.collective_on_payment_helper_tr_chart_based_psp"-->
<!--                                                         chart_base="price"-->
<!--                              />-->
<!--                            </div>-->

<!--                            <div  v-if="dashboard.admin_data.collective_on_payment_helper_tr_chart_based_psp"-->
<!--                                  class="col-12 bg-white border my-2">-->
<!--                              <div class="p-2">{{ $t('label.collective_on_payment_helper_tr_chart_based_psp_count') }}</div>-->
<!--                              <monthly-transaction-chart-based-psp chart_id="collective_on_payment_helper_tr_chart_based_psp_2"-->
<!--                                                         :chart_data="dashboard.admin_data.collective_on_payment_helper_tr_chart_based_psp"-->
<!--                                                         chart_base="count"-->
<!--                              />-->
<!--                            </div>-->
                        </div>

                    </div>
                </div>
            </div>
            <div v-else>
                <div v-if="dashboard.user_data">
                    <user-data :user_data="dashboard.user_data"></user-data>
                    <div v-if="dashboard.user_data.pf_tr_chart" class="col-lg-12 col-md-12 col-sm-12">
                        <user-monthly-transaction-chart :chart_data="dashboard.user_data.pf_tr_chart"/>
                    </div>
                </div>
            </div>
        </div>
        <kt-row v-if="dashboard.login_log">
            <div class="col-lg-12 col-md-12 col-sm-12">
                <login-log :login_log="dashboard.login_log"/>
            </div>
        </kt-row>
    </main-content>
</template>

<script>
    import mainContent from '@/components/main-content'
    import {
        loginLog,
        monthlyTransactionChart,
        userMonthlyTransactionChart,
        rejectedStatusDescription,
        adminData,
        userData,
    } from "./dashboard";
    import Vue from 'vue'
    import {mapGetters} from "vuex";
    import MonthlyTransactionChartBasedPsp from "@/views/dashboard/components/monthly-transaction-chart-based-psp.vue";
    import Starshop_data from "@/views/dashboard/components/starshop_data.vue";
    import starshop_data from "@/views/dashboard/components/starshop_data.vue";

    export default {
        name: 'home',
        components: {
            Starshop_data,
          MonthlyTransactionChartBasedPsp,
            'main-content': mainContent,
            'login-log': loginLog,
            'monthly-transaction-chart': monthlyTransactionChart,
            'rejected_status_description': rejectedStatusDescription,
            'user-monthly-transaction-chart': userMonthlyTransactionChart,
            'user-data': userData,
            'admin-data': adminData,
        },

        data() {
            return {
                chart_base: 'count',
            }
        },
        mounted() {
            this.$store.dispatch('dashboard/fetchDashboard')
        },
        computed: {
            ...mapGetters('dashboard', [
                'dashboard', 'active_board'
            ]),

            board: {
                get: function () {
                    return this.$store.state.dashboard.active_board
                },
                set: function (value) {
                    this.$store.commit('dashboard/setBoard', value)
                }
            }
        },
        methods: {
            changeBoard(board) {
                this.board = board;
            },
        }
    }
</script>

<style>
    .kt-portlet .kt-portlet__body {
        padding: 15px !important;
    }
    .fix-margin {
        margin-bottom: 0 !important;
        margin-top: .75rem !important;
        text-align: center;
    }
    .bg-gr-bluvio {
        background: rgb(102,17,204);
        background: linear-gradient(34deg, rgba(102,17,204,1) 10%, rgba(40,113,250,1) 100%);
        color: #fff
    }
    .bg-gr-oryelo {
        background: rgb(251,82,33);
        background: linear-gradient(34deg, rgba(251,82,33,1) 10%, rgba(248,179,48,1) 100%);
        color: #fff
    }
    .bg-gr-grass {
        background: rgb(4,176,151);
        background: linear-gradient(34deg, rgba(4,176,151,1) 10%, rgba(144,200,64,1) 100%);
        color: #fff
    }
    .bg-gr-ored {
        background: rgb(239,10,116);
        background: linear-gradient(34deg, rgba(239,10,116,1) 10%, rgba(254,101,6,1) 100%);
        color: #fff
    }
    .bg-gr-pinkp {
        background: rgb(246,65,108);
        background: linear-gradient(34deg, rgba(246,65,108,1) 10%, rgba(255,217,90,1) 100%);
        color: #fff
    }
    .bg-gr-midivio {
        background: rgb(151,8,204);
        background: linear-gradient(34deg, rgba(67,203,255,1) 10%, rgba(151,8,204,1) 100%);
        color: #fff
    }
    .bg-gr-viop {
        background: rgb(90,13,228);
        background: linear-gradient(34deg, rgba(90,13,228,1) 10%, rgba(216,102,204,1) 100%);
        color: #fff
    }
    .bg-gr-pivo {
        background: rgb(56,19,194);
        background: linear-gradient(34deg, rgba(56,19,194,1) 0%, rgba(190,17,125,1) 100%);
        color: #fff
    }
    .bg-cad {
        background: #0e5cad;
        color: #fff
    }
    .bg-gr-aqua {
        background: rgb(0,183,235);
        background: linear-gradient(34deg, rgba(0,183,235,1) 10%, rgba(4,220,218,1) 100%);
        color: #fff
    }
    .bg-gr-lime {
        background: rgb(91, 120, 22);
        background: linear-gradient(34deg, rgb(120, 142, 67) 10%, rgb(146, 193, 9) 100%);
        color: #ffffff
    }
    .bg-gr-sunset {
        background: rgb(255,94,58);
        background: linear-gradient(34deg, rgba(255,94,58,1) 10%, rgba(255,153,102,1) 100%);
        color: #fff
    }
    .bg-gr-berry {
        background: rgb(142,45,226);
        background: linear-gradient(34deg, rgba(142,45,226,1) 10%, rgba(233,30,99,1) 100%);
        color: #fff
    }
    .bg-gr-ocean {
        background: rgb(0,95,162);
        background: linear-gradient(34deg, rgba(0,95,162,1) 10%, rgba(0,198,255,1) 100%);
        color: #fff
    }
    .bg-gr-mint {
        background: rgb(20, 143, 113);
        background: linear-gradient(34deg, rgb(53, 147, 123) 10%, rgba(169,255,188,1) 100%);
        color: #171515
    }
    .bg-gr-royal {
        background: rgb(71,59,240);
        background: linear-gradient(34deg, rgba(71,59,240,1) 10%, rgba(120,115,245,1) 100%);
        color: #fff
    }
    .bg-gr-cherry {
        background: rgb(236,0,140);
        background: linear-gradient(34deg, rgba(236,0,140,1) 10%, rgba(252,103,103,1) 100%);
        color: #fff
    }
    .bg-gr-emerald {
        background: rgb(0,148,68);
        background: linear-gradient(34deg, rgba(0,148,68,1) 10%, rgba(0,201,87,1) 100%);
        color: #fff
    }
    .bg-gr-golden {
        background: rgb(255,184,0);
        background: linear-gradient(34deg, rgba(255,184,0,1) 10%, rgba(255,220,79,1) 100%);
        color: #fff
    }
    .bg-navy {
        background: #1a237e;
        color: #fff
    }
    .bg-teal {
        background: #00796b;
        color: #fff
    }
</style>